import React, { useState } from "react";
import ReactQuill from "react-quill";
import "./Editor.css";
const Editor = ({ value, onChange, onBlur, disabled = false, placeholder }) => {
  const [htmlvalue, sethtmlValue] = useState(value || "");
  const modules = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }]
    ]
  };

  const cleanNbsp = (html) => {
    if (!html) return "";
    return html.replace(/&nbsp;/g, " ").replace(/\u00a0/g, " ");
  };
  // Convert <p> to <div>
  const convertQuillHtml = (html) => {
    const container = document.createElement("div");

    container.innerHTML = html;

    container.querySelectorAll("p").forEach((p) => {
      const div = document.createElement("div");

      Array.from(p.attributes).forEach((attribute) => {
        div.setAttribute(attribute.name, attribute.value);
      });

      div.innerHTML = p.innerHTML;

      p.replaceWith(div);
    });

    return container.innerHTML;
  };

  // Convert formatting tags to <span>
  const convertFormattingToSpan = (html) => {
    const container = document.createElement("div");
    container.innerHTML = html;

    // Bold
    container.querySelectorAll("strong, b").forEach((element) => {
      const span = document.createElement("span");
      span.style.fontWeight = "bold";
      span.innerHTML = element.innerHTML;
      element.replaceWith(span);
    });

    // Italic
    container.querySelectorAll("em, i").forEach((element) => {
      const span = document.createElement("span");
      span.style.fontStyle = "italic";
      span.innerHTML = element.innerHTML;

      element.replaceWith(span);
    });

    // Underline
    container.querySelectorAll("u").forEach((element) => {
      const span = document.createElement("span");
      span.style.textDecoration = "underline";
      span.innerHTML = element.innerHTML;
      element.replaceWith(span);
    });

    return container.innerHTML.replace(/<br\s*\/?>/gi, "<br/>");
  };

  const convertContent = (html) => {
    const cleanedHtml = cleanNbsp(html);
    const divContent = convertQuillHtml(cleanedHtml);
    const finalContent = convertFormattingToSpan(divContent);
    return finalContent;
  };
  const handleChange = (html) => {
    sethtmlValue(html);
    const convertedValue = convertContent(html);
    onChange(convertedValue);
  };
  const handleBlur = () => {
    const convertedValue = convertContent(htmlvalue);
    if (onBlur) {
      onBlur(convertedValue);
    }
  };
  return (
    <div>
      <ReactQuill
        theme="snow"
        placeholder={placeholder}
        value={htmlvalue}
        modules={modules}
        onChange={handleChange}
        onBlur={handleBlur}
        readOnly={disabled}
        className={disabled ? "react-quill-readonly" : ""}
      />
    </div>
  );
};

export default Editor;
